"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    env: _propTypes.string,
    language: _propTypes.string,
    avaPositionConfig: (0, _propTypes.shape)({
      top: _propTypes.string,
      right: _propTypes.string,
      bottom: _propTypes.string,
      left: _propTypes.string
    }),
    isLogin: _propTypes.bool,
    enableLogin: _propTypes.bool,
    openAvaOnLogin: _propTypes.bool,
    ssoLoginData: _propTypes.object,
    lemonUserData: _propTypes.object,
    dataConfig: (0, _propTypes.shape)({
      tooltipLabel: _propTypes.string,
      productionID: _propTypes.string,
      stagingID: _propTypes.string
    }),
    imageConfig: (0, _propTypes.shape)({
      imageURL: _propTypes.string,
      width: _propTypes.string,
      height: _propTypes.string,
      radius: _propTypes.string
    }),
    adaEmbedConfig: (0, _propTypes.shape)({
      handle: _propTypes.string,
      parentElement: _propTypes.string,
      metaFields: (0, _propTypes.shape)({
        sso_user_data: _propTypes.string,
        platform: _propTypes.string,
        source: _propTypes.string
      }),
      lang: _propTypes.string
    }),
    gtmEventData: _propTypes.string,
    fireGtm: _propTypes.func,
    isMobile: _propTypes.bool,
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    sourceV2: _propTypes.bool
  },
  DefaultProps: {
    env: _constant2.AVA_DEFAULTS.ENV,
    language: _constant2.AVA_DEFAULTS.LANG,
    avaPositionConfig: {
      top: _constant2.AVA_POSITION_DEFAULTS.TOP,
      right: _constant2.AVA_POSITION_DEFAULTS.RIGHT,
      bottom: _constant2.AVA_POSITION_DEFAULTS.BOTTOM,
      left: _constant2.AVA_POSITION_DEFAULTS.LEFT
    },
    isLogin: false,
    enableLogin: false,
    openAvaOnLogin: false,
    dataConfig: {
      tooltipLabel: _constant2.AVA_DEFAULTS.DATA_CONFIG.TOOLTIP_LABEL,
      productionID: _constant2.AVA_DEFAULTS.DATA_CONFIG.PRODUCTION_ID,
      stagingID: _constant2.AVA_DEFAULTS.DATA_CONFIG.STAGING_ID
    },
    imageConfig: {
      imageURL: _constant2.AVA_DEFAULTS.IMAGE_CONFIG.IMAGEURL,
      width: _constant2.AVA_DEFAULTS.IMAGE_CONFIG.WIDTH,
      height: _constant2.AVA_DEFAULTS.IMAGE_CONFIG.HEIGHT,
      radius: _constant2.AVA_DEFAULTS.IMAGE_CONFIG.RADIUS
    },
    adaEmbedConfig: {
      parentElement: _constant2.AVA_DEFAULTS.ADA.PARENT_ELEMENT,
      metaFields: {
        platform: _constant2.AVA_DEFAULTS.ADA.METAFIELDS.PLATFORM,
        source: _constant2.AVA_DEFAULTS.ADA.METAFIELDS.SOURCE
      }
    },
    isMobile: false,
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    sourceV2: false
  }
};
exports.default = _default;